import ws from '@api/webservice'
import config from '@app/config'
import { fetchPages } from '@api/utils'

const api = {
  all: (societeId?: string, manifestationId?: string) =>
    fetchPages<UserResponse>(
      'users',
      `${config.ws.users.all}${societeId ? `?societeId=${societeId}` : ''}${
        manifestationId ? `?manifestationId=${manifestationId}` : ''
      }`,
      'GET'
    ),
  filtre: (siteId?: string) => ws<UsersBasicList>(config.ws.users.filtre + (siteId ? `?siteId=${siteId}` : ''), 'GET'),
  get: (userId: string) => ws<UserBasicResponse>(config.ws.users.get.replace('{userId}', userId), 'GET'),
  me: () => ws<UserResponse>(config.ws.users.me, 'GET'),
  updateUser: (body: UserUpdateRequest) => ws<UserResponse>(config.ws.users.updateUser, 'PUT', body),
  create: (body: CreationUserRequest) => ws<UserResponse>(config.ws.users.create, 'POST', body),
  update: (id: string, body: CreationUserRequest) =>
    ws<UserResponse>(config.ws.users.update.replace('{userId}', id), 'PUT', body),
  signature: (body: SignatureRequest) => ws<UserResponse>(config.ws.users.signature, 'PUT', body),
}

export default api
